var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0891 7.24619L13.2162 6.37339C13.009 6.16619 12.8392 5.75675 12.8392 5.46315V4.22875C12.8392 3.64155 12.3595 3.16187 11.7725 3.16155H10.5376C10.2443 3.16155 9.8344 2.99147 9.6272 2.78443L8.7544 1.91163C8.33968 1.49691 7.66064 1.49691 7.24592 1.91163L6.37312 2.78507C6.16576 2.99227 5.75536 3.16187 5.46272 3.16187H4.22832C3.64192 3.16187 3.1616 3.64155 3.1616 4.22875V5.46315C3.1616 5.75563 2.99184 6.16635 2.78464 6.37339L1.91168 7.24619C1.49664 7.66091 1.49664 8.33995 1.91168 8.75531L2.78464 9.62811C2.992 9.83531 3.1616 10.2459 3.1616 10.5383V11.7727C3.1616 12.3593 3.64192 12.8396 4.22832 12.8396H5.46272C5.756 12.8396 6.16592 13.0094 6.37312 13.2164L7.24592 14.0895C7.66064 14.5039 8.33968 14.5039 8.7544 14.0895L9.6272 13.2164C9.83456 13.0092 10.2443 12.8396 10.5376 12.8396H11.7725C12.3595 12.8396 12.8392 12.3593 12.8392 11.7727V10.5383C12.8392 10.2446 13.0091 9.83515 13.2162 9.62811L14.0891 8.75531C14.5035 8.33995 14.5035 7.66091 14.0891 7.24619ZM7.15344 10.4006L4.8 8.04683L5.55424 7.29275L7.1536 8.89211L10.4459 5.60059L11.2 6.35467L7.15344 10.4006Z",
    fill: "#33CC99"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheck);
export default __webpack_public_path__ + "static/media/icon-check.7ed7849c934207680d35e9f23e57dd10.svg";
export { ForwardRef as ReactComponent };